import { gql } from 'types/__generated__/gql';

const KEY_ORGANIZATION_CLASSROOM_ENGAGEMENT_ASYNC_QUERY = gql(/* GraphQL */ `
  query getOrganizationClassroomEngagementReportAsync(
    $where: KeyOrganizationClassroomEngagementReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyOrganizationClassroomEngagementReportAsync(where: $where, dateRange: $dateRange) {
      id
      error
      result {
        classroom {
          id
          name
          organizationId
          users {
            userId
            user {
              id
              username
              firstName
              lastName
            }
          }
        }
        activeStudentCount
        totalStudentCount
        totalActivitiesCompletedCount
        averageWeeklyMinutesSpent
        curriculumProgressPercentage
      }
    }
  }
`);

export default KEY_ORGANIZATION_CLASSROOM_ENGAGEMENT_ASYNC_QUERY;
